import { reqAPI } from "../utils/fetch-request";

export async function getFaq(){
  return reqAPI(`api/merchant/faqs`);
}

export async function getProvince(){
  return reqAPI(`api/merchant/province`);
}

export async function getCity(params){
  return reqAPI(`api/merchant/city`, params);
}